module.exports = __webpack_public_path__ + "img/login.c088c8a1.png";